import { getApiUrl } from '../lib/api'
import 'core-js/features/array/includes'

export function openAuthPopup(url) {
  window.open(
    url,
    null,
    'height=600,width=450,menubar=0,toolbar=0,scrollbars=yes'
  )
}

export function onLoginClick(event) {
  event.preventDefault()
  openAuthPopup(getApiUrl('/user/login'))
}

export function checkAccess(user, allowedRoles) {
  return user && user.roles && user.roles.some(r => allowedRoles.includes(r))
}

export class AuthService {
  constructor(storage = window.sessionStorage, tokenKey = 'token') {
    this.storage = storage
    this.tokenKey = tokenKey
  }

  login(token) {
    this.setToken(token)
  }

  logout() {
    this.storage.removeItem(this.tokenKey)
  }

  isLoggedIn() {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken()
    return !!token
  }

  getToken() {
    return this.storage.getItem(this.tokenKey)
  }

  setToken(token) {
    this.storage.setItem(this.tokenKey, token)
  }

  getAuthorizationHeader() {
    if (this.isLoggedIn()) {
      return { Authorization: 'Bearer ' + this.getToken() }
    }
  }
}
